import React, { useEffect, useState, useCallback } from 'react';
import { Form } from 'react-bootstrap';

const LocationSearchInput = (props) => {
    const [autocomplete, setAutocomplete] = useState(null);

    const initAutocomplete = useCallback(async () => {
        if (!window.google) {
            // Wait for the Google Maps script to load
            await window.initMap;
        }

        const { Autocomplete } = await google.maps.importLibrary("places");
        const autocompleteInstance = new Autocomplete(
            document.getElementById('autocompleteloc'),
            { types: ['geocode'] }
        );
        setAutocomplete(autocompleteInstance);
    }, []);

    useEffect(() => {
        initAutocomplete();
    }, [initAutocomplete]);

    const geoLocate = useCallback(() => {
        if (navigator.geolocation && autocomplete) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var geolocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                var circle = new google.maps.Circle({
                    center: geolocation,
                    radius: position.coords.accuracy
                });
                autocomplete.setBounds(circle.getBounds());
            });
        }
    }, [autocomplete]);

    return (
        <Form.Group controlId="autocompleteloc">
            <Form.Control
                type="text"
                value={props.location}
                name="location"
                className="form-size"
                placeholder="Where are you looking for an RV?"
                onFocus={geoLocate}
                onBlur={e => {
                    props.setLocation(e.target.value);
                }}
                onChange={e => {
                    props.setLocation(e.target.value);
                }}
            />
        </Form.Group>
    );
}

export default LocationSearchInput;
